module.exports = __webpack_public_path__ + "static/media/30.0ffb03a2.jpg";